import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Paper, Grid } from '@material-ui/core';

import ViewWrapper from 'views/ViewWrapper';

const styles = theme => ({
  paper: {
    padding: theme.spacing(2),
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
});

const MembershipPerksWrapper = ({ ...props }) => {
  const { classes, children } = props;
  return (
    <ViewWrapper>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography className={classes.title} variant="h5">
                Membership Perks
              </Typography>
            </Grid>
            {children}
          </Grid>
        </Paper>
      </Grid>
    </ViewWrapper>
  );
};

export default withStyles(styles)(MembershipPerksWrapper);
